import React from 'react';
import MitarbeiterList from '../../MitarbeiterList';

/**
 * Mitarbeiterstammdaten in den Einstellungen.
 *
 * MitarbeiterList bringt eigene Ueberschrift, Laden und Fehlerbehandlung mit,
 * deshalb ist dies nur ein Einhaengepunkt fuer den Einstellungs-Drawer.
 */
const MitarbeiterSection: React.FC = () => <MitarbeiterList />;

export default MitarbeiterSection;
